module.exports = __webpack_public_path__ + "static/img/15.e29f1c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/zh/15.png
// module id = a3ZR
// module chunks = 0